"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var FrameWrapper = _styledComponents.default.div.withConfig({
  displayName: "Frame__FrameWrapper",
  componentId: "sc-1xnkzxu-0"
})(["padding:", ";background:", ";border-style:solid;border-width:", ";border-color:", ";border-radius:", ";"], _tokens.default.sky.sys.spacing['300'], _tokens.default.sky.sys.color.background.neutral['2'], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative, _tokens.default.sky.sys.size.borderradius['3']);
var Frame = function Frame(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FrameWrapper, {
    children: children
  });
};
var _default = exports.default = Frame;